import { useSelectedSchool } from '@/contexts/SelectedSchoolContext'

/**
 * Shown at the top of every school-scoped school-admin page (Instructors, Students).
 * With exactly one administered school, shows its name read-only — zero extra steps for
 * the common case. With more than one, requires an explicit choice via <select>; nothing
 * is auto-combined or silently defaulted. With zero, renders nothing — the page itself is
 * responsible for its own "not an admin of any school" empty state.
 */
export function SchoolSwitcher() {
  const { schools, loading, selectedSchoolId, setSelectedSchoolId } = useSelectedSchool()

  if (loading || schools.length === 0) return null

  if (schools.length === 1) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
        <span style={{ font: '500 12.5px Inter, sans-serif', color: 'rgba(27,42,74,0.5)' }}>School:</span>
        <span style={{ font: '600 13px Inter, sans-serif', color: '#1B2A4A' }}>{schools[0].schoolName}</span>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
      <label style={{ font: '500 12.5px Inter, sans-serif', color: 'rgba(27,42,74,0.5)' }}>
        School:
      </label>
      <select
        value={selectedSchoolId}
        onChange={e => setSelectedSchoolId(e.target.value)}
        className='field-input'
        style={{ width: 'auto', padding: '7px 10px' }}
      >
        <option value='' disabled>Select a school…</option>
        {schools.map(s => (
          <option key={s.schoolId} value={s.schoolId}>{s.schoolName}</option>
        ))}
      </select>
    </div>
  )
}
